import {useEffect, useState} from 'react';
import axios from 'axios';
import socket from '../utils/socket';

export const CHAT_READ_EVENT = 'pureworker:chat-read';
export const chatApi = process.env.REACT_APP_BASE_URL || 'https://api.pureworker.com/api';

export default function useUnreadChatCount(enabled = true) {
  const [count, setCount] = useState<number | null>(null);
  useEffect(() => {
    if (!enabled) {setCount(null); return;}
    let controller: AbortController | undefined;
    let timer: ReturnType<typeof setTimeout> | undefined;
    let active = true;
    const refresh = async () => {
      if (document.visibilityState === 'hidden') return;
      controller?.abort();
      const request = new AbortController(); controller = request;
      try {
        const response = await axios.get(`${chatApi}/admin-unread-chats`, {withCredentials:true, signal:request.signal, timeout:15000});
        const value = response.data.chats;
        if (active && !request.signal.aborted && Number.isSafeInteger(value) && value >= 0) setCount(value);
      } catch { /* Keep the last confirmed count; a failed request does not mean zero. */ }
    };
    const schedule = () => {clearTimeout(timer); timer = setTimeout(refresh, 250);};
    void refresh();
    const interval = setInterval(refresh, 30000);
    window.addEventListener(CHAT_READ_EVENT, schedule);
    window.addEventListener('focus', schedule);
    document.addEventListener('visibilitychange', schedule);
    socket.on('message', schedule); socket.on('connect', schedule);
    return () => {
      active = false; controller?.abort(); clearTimeout(timer); clearInterval(interval);
      window.removeEventListener(CHAT_READ_EVENT, schedule);
      window.removeEventListener('focus', schedule);
      document.removeEventListener('visibilitychange', schedule);
      socket.off('message', schedule); socket.off('connect', schedule);
    };
  }, [enabled]);
  return count;
}
